/**
 * @generated SignedSource<<7cba37758c357a1697fe9facdda61682>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableRateCell_cateringOption$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditor_cateringOption">;
  readonly " $fragmentType": "RoomRatesTableRateCell_cateringOption";
};
export type RoomRatesTableRateCell_cateringOption$key = {
  readonly " $data"?: RoomRatesTableRateCell_cateringOption$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateCell_cateringOption">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableRateCell_cateringOption",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesTableRateEditor_cateringOption"
    }
  ],
  "type": "CateringOption",
  "abstractKey": null
};

(node as any).hash = "3b81c1a22d0212b17decb280d3309c8c";

export default node;
